import React, { useEffect, useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PaginationControls from '../components/PaginationControls';
import { getUser } from '../utils/auth';

const DELETE_ALLOWED_ROLES = ['admin', 'masteradmin'];

function CompanyList() {
  const [companies, setCompanies] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();
  const canDelete = DELETE_ALLOWED_ROLES.includes(getUser()?.role);
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch companies from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/companies/get_companies.php?page=${page}`,{
      credentials: 'include'  // This ensures cookies (including session cookies) are sent
    })
      .then(response => response.json())
      .then(data => {
        setCompanies(data.items || []);
        setTotalPages(data.total_pages || 1);
        setTotalRows(data.total_rows || 0);
      })
      .catch(error => console.error('Error fetching companies:', error));
  }, [page]);

  const handleEdit = (id) => {
    navigate(`/config/add-company/${id}`);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      icon: 'warning',
      text: 'Are you sure you want to delete this company?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;

    fetch(`${API_BASE_URL}/companies/delete_company.php?id=${id}`, {
      method: 'DELETE',
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setCompanies(companies.filter(company => company.id !== id));
        } else {
          Swal.fire({ icon: 'warning', text: data.message || 'Failed to delete company' });
        }
      })
      .catch(error => console.error('Error deleting company:', error));
  };

  return (
    <div>
      <h2>List of Companies</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
          <th>#</th>
          <th>Company Name</th>
            <th>Type</th>
            <th>Address</th>
            <th>Contact Information</th>
          </tr>
        </thead>
        <tbody>
          {companies.length > 0 ? (
            companies.map(company => (
              <tr key={company.id}>
                <td></td>
                <td>{company.name}</td>
                <td>{company.company_type === 'external' ? 'External (Vendor)' : 'Internal'}</td>
                <td>{company.address}</td>
                <td>{company.contact_info}</td>
                <td>
                  <Button 
                    variant="warning" 
                    className="me-2" 
                    onClick={() => handleEdit(company.id)}
                  >
                    Edit
                  </Button>
                  {canDelete && (
                  <Button
                    variant="danger"
                    onClick={() => handleDelete(company.id)}
                  >
                    Delete
                  </Button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                No company available.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <PaginationControls page={page} totalPages={totalPages} totalRows={totalRows} onPageChange={setPage} />
      <Link to="/config/add-company">
          <Button variant="primary" className="m-1">Add New Company</Button>
        </Link>
        
    </div>
          
  );
}

export default CompanyList;
